/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Money_MonthInputs */

const en_features_money_month = /** @type {(inputs: Features_Money_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`€3,340`)
};

const pl_features_money_month = /** @type {(inputs: Features_Money_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`12 480 zł`)
};

/**
* | output |
* | --- |
* | "€3,340" |
*
* @param {Features_Money_MonthInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_money_month = /** @type {((inputs?: Features_Money_MonthInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Money_MonthInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_money_month(inputs)
	return en_features_money_month(inputs)
});